export const generalEnquiriesText =
  "General enquiries are not a request to change the contract of sale but rather general questions about the property. \r\n\r\nModify them, or use them as is to speed up your workflow.";

export const customRequestText =
  "Add your custom request as an amendment request to change the contract or a general enquiry about the property.";
